import formatMoney from '@/filters/formatMoney';
import formatNum from '@/filters/formatNum';
import formatPercent from '@/filters/formatPercent';
import formatWithoutSymbols from '@/filters/formatWithoutSymbols';
import { ICustomFilter } from '@/interfaces/ICustomFilter';
import dateToStandart from '@/libs/date/dateToStandart';

const filters: ICustomFilter[] = [
    {
        name: 'formatNum',
        filter: formatNum
    },
    {
        name: 'formatPercent',
        filter: formatPercent
    },
    {
        name: 'formatMoney',
        filter: formatMoney
    },
    {
        name: 'formatWithoutSymbols',
        filter: formatWithoutSymbols
    },
    {
        name: 'dateToStandart',
        filter: dateToStandart
    }
];

export default filters;
